import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './index.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import { store } from './_helpers';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'core-js';
// import ReactGA from 'react-ga';
// const TRACKING_ID = 'UA-144348196-2'; // YOUR_OWN_TRACKING_ID

// ReactGA.initialize(TRACKING_ID);
ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js